import React, { Component, createRef } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { withTranslation } from "react-i18next";
import parse from 'html-react-parser';                                              //Parse HTML data from string
import ReCaptcha from 'react-google-invisible-recaptcha';                           //Google Recaptcha
import flatpickr from "flatpickr";     
import { German } from "flatpickr/dist/l10n/de.js";                                 //Date Picker
import Aux from '../../hoc/Auxiliare';
import GLOBAL_CONFIG from '../../config/config';
import ValidateForm from '../../modules/validate';                                  //Form validation module
import appGoogleTracking from '../../modules/googletracking';                       //Google tracking module
import { mainLoaderToggle, navParticipationMenu, timeStamp, dateConfig } from '../../modules/helpers';
import TitleContent from '../../components/Content/TitleContent/TitleContent';
import GiftContentFooter from '../../components/Content/GiftContent/GiftContentFooter';
import Salutations from '../../Models/Salutation';
//CSS import for Datepicker
import 'flatpickr/dist/flatpickr.css';
import CampaignServices from '../../Services/Campaign';
import _LOCAL_CAPTCHA from '../../Models/Captcha';
import _MATH from '../../modules/Math';
import StepContent from '../../components/Content/StepContent/StepContent';

//Google Recaptcha reference
//const recaptchaRef = React.createRef();

// window.PROMOTION_CAMPAIGN

class Participation extends Component {

    constructor(props) {
        super(props);

        this.scrollToRef = createRef();

        this.handleUnload = this.handleUnload.bind(this);       //Binding to check for Abondanment form for Google tracking

        var limit = new Date();
        limit.setFullYear(limit.getFullYear() - 18);
        this.maxDOB = limit;
        this.DateFormat = 'd.m.Y';
        this.errorMessage = "Ein Fehler ist aufgetreten. Bitte versuchen <br />Sie es später noch einmal.";
        this.DefaultSum = "xx";
        this.ReceiptSymbol = "€";

        this.state = {
            minDate: dateConfig({
                promotion: window.PROMOTION_CAMPAIGN,       //Minimum Purchase date
                status: 'min',
                ...GLOBAL_CONFIG.Date
            }),
            maxDate: this.getMaxDate(),
            ReceiptSum: this.DefaultSum,
            IsAdventCalendar: false,
            genericErrorMessage: "",
            CodeIsValid: true,
            MoreTerms: false,
            loaderSubmit: false,
            loaderError: false,
            loaderGeneralError: false,
            promotionCampaign: window.PROMOTION_CAMPAIGN,
            isMobile: false,
            IsProductAmountInvalid: false,
            IsProductNameInvalid: false,
            selectedRetailer: "",
            selectedRetailerPartner: "",
            showRetailerPartner: false,
            prizeAvailableError: '',
            sumValue: '',
            showSymbol: false,

            //formParticipation
            salutation: null,
            firstName: null,
            lastname: null,
            email: null,
            is18: null,
            country: null,
            newsletter: null,
            privacyPolicy: null,
            token: null,
            showPopup: false,
            errorFile: false,

        };

        this.DisplayRecieptForm = this.DisplayRecieptForm.bind(this);
        this.DisplaySteps = this.DisplaySteps.bind(this);
        this.DisplayParticipationDetails = this.DisplayParticipationDetails.bind(this);
        this.DisplayReweSpecific = this.DisplayReweSpecific.bind(this);
        this.DisplayDateAndProductCount = this.DisplayDateAndProductCount.bind(this);
        this.ProcessError = this.ProcessError.bind(this);
        this.ProcessFormData = this.ProcessFormData.bind(this);
        this.TriggerCaptcha = this.TriggerCaptcha.bind(this);
        this.resize = this.resize.bind(this);
        // this.checkProductAmount = this.checkProductAmount.bind(this);
        // this.checkMinValueOfProductAmount = this.checkMinValueOfProductAmount.bind(this);
        this.checkProductName = this.checkProductName.bind(this);
        this.checkMinValueOfProductName = this.checkMinValueOfProductName.bind(this);
        this.googleTag = this.googleTag.bind(this);
        this.handleFile = this.handleFile.bind(this);
        // this.showData = this.showData.bind(this);
    }

    resize() {
        // set isMobile to true if the device is a mobile and false otherwise 
        this.setState({ isMobile: window.innerWidth <= 768 });
    }
    //huhu_validation size 
    handleFile = (e) => {
        const file = e.target.files[0];
        const maxSizeInBytes = 10 * 1024 * 1024; // 3 Mo
        const allowedExtensions = ['jpg', 'jpeg', 'pdf'];
        const fileName = file.name.toLowerCase();
        const fileExtension = fileName.slice((fileName.lastIndexOf('.') - 1 >>> 0) + 2);
        const fileColorBtn = document.getElementById('fileColorBtn');
        const fileConditionParagraph = document.getElementById('fileCondition');
        if (!allowedExtensions.includes(fileExtension)) {
            fileColorBtn.classList.remove('btn--secondary-medow');
            fileConditionParagraph.style.color = 'red';
            return;
        }
        if (file.size > maxSizeInBytes) {
            fileColorBtn.classList.remove('btn--secondary-medow');
            fileConditionParagraph.style.color = 'red';
            return;
        }
        else {
            fileConditionParagraph.style.color = '#3b2774';
            this.setState({ errorFile: false });
            this.googleTag('choose_file', 'Take Part Page', 'Click on Choose A File', 'EASTER_TPP_PART')
        }
    }
    getMaxDate() {
        var maxDate = dateConfig({
            promotion: window.PROMOTION_CAMPAIGN,       //Maximum Purchase date
            status: 'max',
            ...GLOBAL_CONFIG.Date
        });
        var splitDate = maxDate.split(".");
        const dt = new Date(splitDate[2], splitDate[1] - 1, splitDate[0]);
        const now = new Date();
        if (now < dt) {
            const day = now.getDate();
            const month = now.getMonth() + 1;
            const year = now.getFullYear();
            return `${day}.${month}.${year}`;
        }
        return maxDate;
    }

    componentDidMount() {

        const { t } = this.props;
        //Remove main loader
        mainLoaderToggle('hide');


        //Date picker for purchase receipt date
        if (!!this._RECEIPT_ReceiptDate) {
            flatpickr(this._RECEIPT_ReceiptDate, {
                locale: German,
                dateFormat: this.DateFormat,
                minDate: this.state.minDate,
                maxDate: this.state.maxDate,
                disableMobile: true
            });
        }

        //Assign Validation function
        ValidateForm.validateField('frm_participation');    //parameter : form id

        const link1 = document.getElementById('link_18');
        if(link1){
            link1.addEventListener('click', function (event) {
                appGoogleTracking.dataLayerPush({
                    'dataEvent': 'data_protection',
                    'dataCategory': 'Take Part Page',
                    'dataAction': 'Click on Data Protection',
                    'dataLabel': 'ENG_TPP_PART'
                });
            });
        }

        //huhu_q 
        //Virtual page
        // appGoogleTracking.dataLayerPush({
        //     'customEvent': {
        //         'event': 'virtual-page',
        //         'virtualUri': GLOBAL_CONFIG.Route.participation,
        //         'pageTitle': t('Meta.title')
        //     }
        // });

        //Tagging for Form Type in and abondonment form
        // appGoogleTracking.formHandlers({
        //     abandonStatus: true,
        //     typeInSelector: '.js-event-type-in',
        //     formID: 'frm_participation',
        //     abSelector: '.js-event-ab',
        //     abPrefillSelector: '.js-event-ab-prefilled'
        // });

        window.addEventListener('beforeunload', this.handleUnload);
        window.addEventListener("resize", this.resize);
        this.resize();
    }
    componentWillMount() {

    }
    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.handleUnload);


        //Show mainloader
        mainLoaderToggle('show');
    }

    scroll() {
        const section = document.querySelector('#frm_participation');
        if (section) {
          const headerHeight = 80; // Adjust this if your header height changes
          const sectionPosition = section.getBoundingClientRect().top + window.scrollY - headerHeight;
          
          window.scrollTo({ top: sectionPosition, behavior: 'smooth' });
      }
    }

    //Render of the HTML
    render() {
        const { t } = this.props;

        let image = {
            desktop: t('Page.Holding.bottomBanner.desktop'),
            mobile: t('Page.Holding.bottomBanner.mobile')
        };

        
        return (
            <Aux>
                <div className={`content-home content-home__${window.PROMOTION_CAMPAIGN}`}>
                <div className="content-home content-participation content-home__container container-home">
                    <TitleContent
                        heading={this.state.isMobile ? parse(t('Page.Participation.title.mobile')) : parse(t('Page.Participation.title.desktop'))}
                        paragraph={this.state.isMobile ? parse(t('Page.Participation.paragraphMob')):parse(t('Page.Participation.paragraph'))}
                    />
                    <NavLink
                      to={GLOBAL_CONFIG.Route.home}
                      exact
                      data-event="join_now"
                      data-category="Start Page"
                      data-action="Click on Join Now"
                      data-label="ENG_SP_OTHER"
                      onClick={(e) => {
                        appGoogleTracking.processEventCTANavLink(e);
                        this.scroll(e)
                        }
                      }
                    >
                      <div className="btn__container btn--primary btn--hover">
                        
                        <span className="btn__text" style={{ fontSize: '16px' }}>
                          {t("Page.Home.linkParticipation")}
                        </span>
                      </div>
                    </NavLink>
                </div>
                {/* {this.DisplaySpecificParticipationImage(t)} */}


                <div className='.content-home__gluecksrad'>
                    <StepContent title={this.state.isMobile ? parse(t('Page.Participation.stepsTitle')) : parse(t('Page.Participation.stepsTitle'))}
                        toScroll={this.scroll} isMobile={this.state.isMobile}
                    t={t} />
                    {/* <StepContent title='SO EINFACH GEHT’S'/> */}
                </div>
                <div className='content-home content-prizes'>
                    <TitleContent 
                        heading= {parse(t('Page.Participation.prize.title'))}
                        paragraph={parse(t('Page.Participation.prize.subTitle'))}
                    />
                    <div className="container-steps">
						<div className="container-steps__steps">
							<div className="s-content-steps__item">
								<div className="s-content-steps__item-image">
									<img   
                                        className='image'
										src={parse(t('Page.Participation.prize.prizes.prize1.image.path'))}
										alt={parse(t('Page.Participation.prize.prizes.prize1.image.alt'))}
									/>
								</div>
                                <div className="s-content-steps__item-text">
                                    <h2>
                                        {parse(t('Page.Participation.prize.prizes.prize1.title'))}
                                    </h2>
                                    <p className="s-content-steps__item__text">
                                    {this.state.isMobile? parse(t('Page.Participation.prize.prizes.prize1.descriptionMob')): parse(t('Page.Participation.prize.prizes.prize1.description'))}
                                    </p>
                                </div>
							</div>
							<div className="s-content-steps__item">
								<div className="s-content-steps__item-image">
									<img
                                        className='image'
										src={parse(t('Page.Participation.prize.prizes.prize2.image.path'))}
										alt={parse(t('Page.Participation.prize.prizes.prize2.image.alt'))}
									/>
								</div>
                                <div className="s-content-steps__item-text">
                                    <h2>
                                        {parse(t('Page.Participation.prize.prizes.prize2.title'))}
                                    </h2>
                                    <p className="s-content-steps__item__text">
                                        {parse(t('Page.Participation.prize.prizes.prize2.description'))}
                                    </p>
                                </div>
							</div>
							<div className="s-content-steps__item">
								<div className="s-content-steps__item-image">
                                <img
                                        className='image'
										src={parse(t('Page.Participation.prize.prizes.prize3.image.path'))}
										alt={parse(t('Page.Participation.prize.prizes.prize3.image.alt'))}
									/>
								</div>
                                <div className="s-content-steps__item-text">
                                    <h2>
                                        {parse(t('Page.Participation.prize.prizes.prize3.title'))} 
                                    </h2>
                                    <p className="s-content-steps__item__text">
                                        {parse(t('Page.Participation.prize.prizes.prize3.description'))}
                                    </p>
                                </div>
                            </div>
                        </div>
				    </div>
                    <div className='content-home__container' style={{ marginTop: '40px'}}>
                    <NavLink
                        to={GLOBAL_CONFIG.Route.home}
                        exact
                        data-event="join_now"
                        data-category="Start Page"
                        data-action="Click on Join Now"
                        data-label="ENG_SP_OTHER"
                        onClick={(e) => {
                            appGoogleTracking.processEventCTANavLink(e);
                            const particaptionForm = document.getElementById('frm_participation');
                            this.scroll(e)
                            }
                        }
                        >
                        <div className="btn__container btn--primary btn--hover">
                            
                            <span className="btn__text" style={{ fontSize: '16px' }}>
                            {t("Page.Home.linkParticipation")}
                            </span>
                        </div>
                        </NavLink>
                    </div>
                    <p className="redirect-terms-h" style={{fontSize:'16px'}}>
						<NavLink
							to={GLOBAL_CONFIG.Route.terms}
							exact
							data-event="click_conditions"
							data-category="Start Page"
							data-action="Click on Conditions of Participation"
							data-label="ENG_SP_PART"
							onClick={appGoogleTracking.processEventCTANavLink}
							target="_blank"
						>
							Teilnahmebedingungen
						</NavLink>{" "}
						des Gewinnspiels
					</p>
                    <p className='end-para'>
                        {parse(t('Page.Participation.prize.endParagraph'))}
                    </p>
                </div>
                
                {this.DisplayParticipationDetails(t)}
                {
                    this.state.loaderSubmit ?
                        <div className="simple-loader__container active">
                            <div className="simple-loader__indicator"></div>
                        </div>
                        : null
                }
                {
                    this.state.loaderError ?
                        <div className="js-overlay overlay overlay--black">
                            <div className="overlay__container overlay__content">
                                <div className="overlay__close" onClick={this.onClosePopupHandler}></div>
                                <p className="overlay__title">Du hast bereits 3x an der Aktion teilgenommen.</p>
                                <p id="js-error-msg">Über den gesamten Gewinnspielzeitraum ist eine dreimalige Teilnahme mit jeweils neuem gültigem Kassenbon erlaubt. Eine weitere Teilnahme ist leider nicht möglich.</p>
                                <div className="overlay__footer">
                                    <p>Du möchtest wissen, welche Neuigkeiten es bei Milka gibt?</p>
                                    <a href="https://www.milka.de/neues" target="_blank" rel="noopener noreferrer">
                                        <div className="btn__container btn--primary btn--hover">
                                            <span className="btn__text">NEUES VON MILKA</span>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div> : null
                }
                {
                    this.state.loaderGeneralError ?
                        <div className="js-overlay overlay overlay--black">
                            <div className="overlay__container overlay__content">
                                <div className="overlay__close" onClick={this.onClosePopupHandler}></div>
                                <p id="js-error-msg">{parse(this.state.genericErrorMessage)}</p>
                            </div>
                        </div> : null
                }
                </div>
            </Aux>
        );
    }

    DisplaySpecificParticipationImage(t) {
        // if(window.PROMOTION_CAMPAIGN != "netto"){
        //     return null;
        // }

        let imageSpecific = {
            // desktop: t('Page.Participation.specificImage.desktop'),
            desktop: t('/resources/images/alle/img-eggs.png'),
            mobile: t('/resources/images/alle/img-eggs-mobile.png'),
        };

        return (
            <div className={`participation-image__specific`}>
                <picture>
                    {/* <source srcSet={imageSpecific.desktop} media="(min-width: 1024px)" /> */}
                    {/* <source srcSet={imageSpecific.desktop} media="(min-width: 481px)" /> */}
                    <source srcSet={imageSpecific.mobile} media="(max-width: 481px)" />
                    <img src={imageSpecific.desktop} alt="Milka Christmas product" />
                </picture>
            </div>
        )
    }

    DisplaySteps(t) {
        return (
            <div className="content-gift-wrapper">
                <div className="content-list-wrapper">
                    <div className="campaign-description-container">
                        <h3 className="sub-title">{this.state.isMobile ? parse(t("Page.Participation.description.Title.mobile")) : parse(t("Page.Participation.description.Title.desktop"))}</h3>
                        <ul>
                            {
                                t("Page.Participation.description.Steps", { returnObjects: true }).map(step => {
                                    return (
                                        <li className="liste">
                                            {step.map((element) => {
                                                if (element.type === "link") {
                                                    return (
                                                        <a className='to-scroll' data-event={element.dataEvent} data-category={element.dataCategory} data-action={element.dataAction} data-label={element.dataLabel} onClick={(e) => { appGoogleTracking.processEventCTANavLink(e); this.scroll(); }} >{parse(element.text)}</a>
                                                    );
                                                } else {
                                                    return parse(element.text);
                                                }
                                            })}
                                        </li>
                                    )
                                })
                            }
                        </ul>
                        <p className="paragraph">{parse(t('Page.Participation.description.Caption'))}</p>
                    </div>
                </div>
                <picture>
                    <source srcSet={t('Page.Participation.description.image.desktop')} media="(min-width: 1024px)" />
                    <source srcSet={t('Page.Participation.description.image.desktop')} media="(min-width: 481px)" />
                    <source srcSet={t('Page.Participation.description.image.mobile')} media="(min-width: 200px)" />
                    <img src={t('Page.Participation.description.image.desktop')} alt="Milka Easter" />
                </picture>
            </div>
        );
    }

    DisplayParticipationDetails(t) {
        //Get Google recaptcha
        let _captcha = _LOCAL_CAPTCHA[this.state.promotionCampaign];
        return (<>
            <form
                id="frm_participation"
                name="frm_participation"
                method="post"
                action="/"
                onSubmit={this.onSubmitHandler.bind(this)} noValidate>
            <div className={`content-prize content-prize__${window.PROMOTION_CAMPAIGN}`} style={{ marginTop: "50px" }}>
                    
                    {/* <form
                        id="frm_receipt"
                        name="frm_receipt"
                        method="post"
                        action="/"
                        onSubmit={this.onSubmitHandler.bind(this)} noValidate> */}
                    {this.DisplayRecieptForm(t)}

                    {/* </form> */}
            </div>
            <div className="s-content-partication">
                

                    {/* { this.DisplayRecieptForm(t) } */}

                    {/* <hr className="purple-line-bottom-text start-form-participation" /> */}

                    {this.DisplayParticipantForm(t)}

                    <div className="form-container centered" style={{zIndex: '3'}}>
                        <ReCaptcha
                            ref={ref => this._CAPTCHA = ref}
                            locale={_captcha.lang}
                            sitekey={_captcha.key}
                            onResolved={this.onResolved}
                        />
                    </div>

                    <span className="form-input__error active">{this.state.prizeAvailableError && this.state.prizeAvailableError}</span>
                    <button type="submit" style={{ width: '320px', fontSize: '16px', marginBottom: '0'}} className="btn__container btn--primary btn__margin"
                        onClick={() => {
                            // this.scroll();
                        }
                        }>
                        JETZT GLÜCKSRAD DREHEN!
                    </button>


            </div>
            </form>

                <div className="content-participation-footer">
                    <GiftContentFooter btnShow={false} hrShow={false} />
                </div>
            </>
        );
    }

    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    DisplayDateAndProductCount(t) {
        const dataLayer = window.dataLayer || [];
        const { sumValue, showSymbol } = this.state;
        return (
            <>
                <div id="inputs" className="inputs">
                    <div className="form-input__container form-input__dropdown form-input__dropdown1">
                        <input
                            className="form-input__input js-event-type-in js-event-ab  input-top"
                            type={t("Page.Participation.Form.Sections.Receipt", { returnObjects: true }).Field.ReceiptDate.Type}
                            name={t("Page.Participation.Form.Sections.Receipt", { returnObjects: true }).Field.ReceiptDate.Id}
                            id={t("Page.Participation.Form.Sections.Receipt", { returnObjects: true }).Field.ReceiptDate.Id}
                            placeholder={t("Page.Participation.Form.Sections.Receipt", { returnObjects: true }).Field.ReceiptDate.Label}
                            data-require={t("Page.Participation.Form.Sections.Receipt", { returnObjects: true }).Field.ReceiptDate.Required}
                            data-type="regex"
                            data-error-target={`#error-${t("Page.Participation.Form.Sections.Receipt", { returnObjects: true }).Field.ReceiptDate.Id}`}
                            data-regex-pattern="^\s*(3[01]|[12][0-9]|0?[1-9])\.(1[012]|0?[1-9])\.((?:19|20)\d{2})\s*$"
                            data-required-message=""
                            data-pattern-message=""
                            data-event-fieldname="date"
                            // data-event="date_of_purchase"
                            // data-category="Take Part Page"
                            // data-action="Select date"
                            // data-label="test"
                            data-date-min={this.state.minDate}
                            data-date-max={this.state.maxDate}
                            data-date-message=""
                            ref={input => this._RECEIPT_ReceiptDate = input}
                            onSelect={e => {
                                const selectedDate = e.target.value; // Capture the selected date value
                                // Check if the selected date is not empty and not already present in the dataLayer
                                if (selectedDate && !dataLayer.some(entry => entry.dataLabel === selectedDate)) {
                                    appGoogleTracking.dataLayerPush({
                                        'dataEvent': 'date_of_purchase',
                                        'dataCategory': 'Start Page',
                                        'dataAction': 'Select Date',
                                        'dataLabel': selectedDate
                                    });
                                }
                            }}
                        />

                    </div>
                    

                    <div className="form-input__container">
                        {/* <label className="form-input__label" htmlFor={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Id} >{t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Label}</label> */}
                        <input className="form-input__input js-event-type-in js-event-ab"
                            type={t("Page.Participation.Form.Sections.Receipt.Field.ProductName.Type")}
                            name={t("Page.Participation.Form.Sections.Receipt.Field.ProductName.Name")}
                            id={t("Page.Participation.Form.Sections.Receipt.Field.ProductName.Id")}
                            placeholder={t("Page.Participation.Form.Sections.Receipt.Field.ProductName.Placeholder")}
                            data-require={t("Page.Participation.Form.Sections.Receipt.Field.ProductName.Required")}
                            data-type="regex"
                            maxLength={50}
                            data-error-target={`#error-${t("Page.Participation.Form.Sections.Receipt.Field.ProductName.Id")}`}
                            data-regex-pattern="^[a-zA-ZäéèöüßÉÈÄÖÜ0-9 ,]+$"
                            data-required-message=""
                            data-event-fieldname="Product Name"
                            data-event="form-click"
                            data-category="Form Action"
                            data-action="Product Name"
                            data-label="Type In"
                            ref={input => this._RECEIPT_ProductName = input}
                        />

                        <span id={`error-${t("Page.Participation.Form.Sections.Receipt.Field.ProductName.Id")}`} className="form-input__error active"></span>
                    </div>

                    <div className="form-input__container">
                        <div className='input-wrapper'>

                        {/* <label className="form-input__label" htmlFor={t("Page.Participation.Form.Sections.Receipt", { returnObjects: true }).Field.ReceiptPrice.Id} >{t("Page.Participation.Form.Sections.Receipt", { returnObjects: true }).Field.ReceiptPrice.Label}</label> */}
                        <input className="form-input__input js-event-type-in js-event-ab input-top"
                            type={t("Page.Participation.Form.Sections.Receipt.Field.SumReceipt.Type")}
                            name={t("Page.Participation.Form.Sections.Receipt.Field.SumReceipt.Name")}
                            id={t("Page.Participation.Form.Sections.Receipt.Field.SumReceipt.Id")}
                            placeholder={t("Page.Participation.Form.Sections.Receipt.Field.SumReceipt.Placeholder")}
                            data-require={t("Page.Participation.Form.Sections.Receipt.Field.SumReceipt.Required")}
                            data-type="regex"
                            data-error-target={`#error-${t("Page.Participation.Form.Sections.Receipt.Field.SumReceipt.Id")}`}
                            data-regex-pattern="^[1-9]\d*((\.|\,)\d+)?$"
                            data-required-message=""
                            maxLength={7}
                            data-event-fieldname="Sum of Receipt"
                            data-event="form-click"
                            data-category="Form Action"
                            data-action="Sum of Receipt"
                            data-label="Type In"
                            ref={input => this._RECEIPT_SumReceipt = input}
                            value={sumValue === '€'? '': sumValue}
                            onChange={(event) => {
                                const inputValue = event.target.value.replace(/[^0-9.,]/g, '');
                                this.setState({ 
                                sumValue: inputValue, 
                                showSymbol: inputValue.length > 0
                                });
                            }}

                            
                        />
                        {showSymbol && <span className="currency-symbol">€</span>}
                        </div>
                        <span id={`error-${t("Page.Participation.Form.Sections.Receipt.Field.SumReceipt.Id")}`} className="form-input__error active"></span>
                    </div> 

                    <div className="form-input__container form-input__dropdown">
                        {/* <label className="form-input__label" htmlFor={t("Page.Participation.Form.Sections.Receipt", { returnObjects: true }).Field.Retailer.Id} >
                            {t("Page.Participation.Form.Sections.Receipt", { returnObjects: true }).Field.Retailer.Label}
                        </label> */}
                        <select
                        style={{fontFamily: 'Good Headline Pro'}}
                        ref={(select) => (this._RECEIPT_Retailer = select)}
                        className="form-input__input js-event-type-in js-event-ab flatpickr-input"
                        type="text"
                        name="retailer"
                        id="retailer"
                        data-require="true"
                        data-type="ddl"
                        data-error-target="#error-retailer"
                        data-required-message=""
                        data-event-fieldname="Retailer"
                        onChange={(event) => {
                            let selectedRetailer = event.target.value;
                            let validRetailers = t(
                            "Page.Participation.Form.Sections.Receipt.Field.Retailer.ValidRetailers",
                            { returnObjects: true }
                            );
                            let validRetailerPartners = t(
                                "Page.Participation.Form.Sections.Receipt.Field.RetailerPartner.ValidRetailerPartners",
                                { returnObjects: true }
                                );
                            if (!validRetailers.includes(event.target.value)) {
                            this.setState({ isRetailerInvalid: true });
                            event.target.classList.add("notvalid");
                            event.target.classList.remove("valid");
                            } else {
                            this.setState({ isRetailerInvalid: false });
                            event.target.classList.add("valid");
                            event.target.classList.remove("notvalid");
                            }
                            this.setState({
                                selectedRetailer,
                                showRetailerPartner: !validRetailerPartners.includes(selectedRetailer),
                            })
                            this.setState({selectedRetailer: event.target.value}, () => {
                            appGoogleTracking.dataLayerPush({
                                dataEvent: 'buy_milka_products',
                                dataCategory: 'Start Page',
                                dataAction: 'Select Buying Location of Products',
                                dataLabel: this.state.selectedRetailer,  // Use the updated value
                            });
                            });
                        }}
                        value={this.state.selectedRetailer} // Set the default value here
                        >
                        {t("Page.Participation.Form.Sections.Receipt", {
                            returnObjects: true,
                        }).Field.Retailer.Options.map((retailer, index) => {
                            var { display, value } = retailer;
                            return (
                            <option value={value} key={`${value}-${index}`}>
                                {display}
                            </option>
                            );
                        })}
                        </select>
                    </div>

                    {this.state.showRetailerPartner && (

                    <div>
                        <p style={{maxWidth: '395px', margin: 'auto'}}>Von welchem dieser Handelspartner möchtest du im Gewinnfall einen Wertgutschein erhalten?</p>
                        <div className="form-input__container form-input__dropdown">
                            {/* <label className="form-input__label" htmlFor={t("Page.Participation.Form.Sections.Receipt", { returnObjects: true }).Field.Retailer.Id} >
                                {t("Page.Participation.Form.Sections.Receipt", { returnObjects: true }).Field.Retailer.Label}
                            </label> */}
                            <select
                            ref={(select) => (this._RECEIPT_RetailerPartner = select)}
                            style={{fontFamily: 'Good Headline Pro'}}
                            className="form-input__input js-event-type-in js-event-ab flatpickr-input"
                            type="text"
                            name="retailerPartner"
                            id="retailerPartner"
                            data-require="true"
                            data-type="ddl"
                            data-error-target="#error-retailerPartner"
                            data-required-message=""
                            data-event-fieldname="RetailerPartner"
                            onChange={(event) => {
                                let validRetailers = t(
                                "Page.Participation.Form.Sections.Receipt.Field.RetailerPartner.ValidRetailerPartners",
                                { returnObjects: true }
                                );
                                if (!validRetailers.includes(event.target.value)) {
                                this.setState({ isRetailerInvalid: true });
                                event.target.classList.add("notvalid");
                                event.target.classList.remove("valid");
                                } else {
                                this.setState({ isRetailerInvalid: false });
                                event.target.classList.add("valid");
                                event.target.classList.remove("notvalid");
                                }
                                this.setState({selectedRetailerPartner: event.target.value}, () => {
                                appGoogleTracking.dataLayerPush({
                                    dataEvent: 'select_trading_partners',
                                    dataCategory: 'Start Page',
                                    dataAction: 'Select Trading Partners ',
                                    dataLabel: this.state.selectedRetailerPartner,  // Use the updated value
                                });
                                });
                            }}
                            value={this.state.selectedRetailerPartner} // Set the default value here
                            >
                            {t("Page.Participation.Form.Sections.Receipt", {
                                returnObjects: true,
                            }).Field.RetailerPartner.Options.map((retailerPartner, index) => {
                                var { display, value } = retailerPartner;
                                return (
                                <option value={value} key={`${value}-${index}`}>
                                    {display}
                                </option>
                                );
                            })}
                            </select>
                        </div>
                    </div>
                    )}

                </div>
                {this.state.IsProductNameInvalid && (
                    <p className="product-amount-error">
                        {
                            window.PROMOTION_CAMPAIGN === "rewe" && this.state.IsAdventCalendar ?
                                t("Page.Participation.Form.Sections.Receipt.Field.ProductName.ErrorMessageAdventCalendar")
                                :
                                t("Page.Participation.Form.Sections.Receipt.Field.ProductName.ErrorMessage")
                        }
                    </p>
                )}

                {window.PROMOTION_CAMPAIGN === "kaufland" ?
                    <p className="receipt-sum">
                        Wir runden deinen Kaufbeleg immer auf den nächsten glatten Betrag auf.
                        {/* <span> {_MATH.RoundUp(this.state.ReceiptSum)} {this.ReceiptSymbol}</span> */}
                    </p> : null
                }
            </>
        
        );
    }
    DisplayRecieptForm(t) {
        const campaignName =
            window.PROMOTION_CAMPAIGN == "muller"
                ? "Mueller"
                : this.capitalizeFirstLetter(window.PROMOTION_CAMPAIGN);

        const messageFileRequired = `Du hast noch keine Rechnung hochgeladen. Wähle die entsprechende Datei aus und lade deine Rechnung hoch. Bitte denke dabei daran, die nicht an der Aktion teilnehmenden Artikel auf dem Kaufbeleg unkenntlich zu machen.`;
        return (
            <div className="campaign-form-receipt">
                <a id="section1" ></a>

                <h3>
                    {
                        t("Page.Participation.Form.Sections.Receipt", {
                            returnObjects: true,
                        }).Title
                    }
                </h3>
                <img
                    src="/resources/images/upload-receipt-imgage.png"
                    width="156"
                    height="173"
                    alt="upload receipt"
                />
                <label id='fileColorBtn' className="btn__container btn--primary btn--hover custom-file-btn" htmlFor="file_to_upload">
                    <span className="desktop-only">
                      RECHNUNG hochladen
                    </span>
                    <input
                        ref={(fileInput) => (this._RECEIPT_file = fileInput)}
                        type="file"
                        id="file_to_upload"
                        name="file_to_upload"
                        data-require="true"
                        data-file-required="true"
                        data-type="file"
                        data-error-target="#error-file"
                        data-required-message={messageFileRequired}
                        data-oversize-error="Ungültige Dateigröße. Bitte beachten Sie, dass die erforderliche Dateigröße weniger als 10 MB beträgt."
                        data-format-error="Ungültiges Dateiformat. Bitte nur gültiges Format hochladen."
                        onClick={() => {
                                appGoogleTracking.dataLayerPush({
                                    dataEvent: "upload_receipt_link",
                                    dataCategory: "Start Page",
                                    dataAction: "Click on Link",
                                    dataLabel: "GAME_SP_FORM",
                                });
                        }}
                    />
                </label>

                {/* {
                    this.state.errorFile ?
                        <div className='form-input__container'>
                            <span className="form-input__error active">Du hast noch keinen Kaufbeleg hochgeladen. Wähle die entsprechende Datei aus
                                und lade deinen Kaufbeleg hoch. Bitte denke dabei daran, die nicht an der Aktion
                                teilnehmenden Artikel auf dem Kaufbeleg unkenntlich zu machen.
                            </span>
                        </div>
                        : null
                } */}
                <p className="info-receipt" id='fileCondition'>
                {
                        t("Page.Participation.Form.Sections.Receipt", {
                            returnObjects: true,
                        }).Info
                    }
                </p>
                <div className="form-container results">
                    <span className="form-input__error js-file-error">Error</span>
                    {/* {   
                        this.state.errorFile ?null: */}
                        <span className="form-input__success js-file-success">Success</span>
                    {/* } */}
                </div>
                {this.DisplayDateAndProductCount(t)}
                {this.DisplayWinInfo()}
            </div>
        );
    }


    DisplayWinInfo(t) {
        if (window.PROMOTION_CAMPAIGN === "edeka") {
            return null;
        }

        if (window.PROMOTION_CAMPAIGN === "rewe") {
            return (
                <p className="info-win">
                    Solltest du diese Woche unter den 100 glücklichen Gewinnern sein, gewinnst du einen REWE Einkaufsgutschein im Wert von 50€.
                </p>
            );
        }

        if (window.PROMOTION_CAMPAIGN === "muller") {
            return (
                <p className="info-win">
                    Solltest du unter den glücklichen Gewinnern sein, gewinnst du einen CEWE Gutschein für eine Postkarte inkl. Versand.
                </p>
            );
        }

        if (window.PROMOTION_CAMPAIGN === "netto") {
            return (
                <p className="info-win">
                    Wenn alle Teilnahmebedingungen erfüllt sind, erhältst du deine persönliche Baumurkunde und hast zusätzlich die Chance auf <strong>1 von 2 Baumhaushotel-Gutscheinen im Wert von je 3000€ von mydays.</strong>
                </p>
            );
        }
        return null;
    }

    DisplayReweSpecific(t) {
        return (
            <>
                <div id="rewe-specific">
                    <div className="container">
                        <h4>Hast du den Milka & REWE Adventskalender gekauft?</h4>
                        <div className="custom-radio__container">
                            <input className="custom-radio__input"
                                id="Yes"
                                name="customisation-choice"
                                type="radio"
                                value="yes"
                                hidden
                                checked={this.state.IsAdventCalendar}
                            />
                            <label onClick={(event) => { this.LabelClicked(event, t) }} className="custom-radio__label custom-radio__label_content--option-name" for="Yes">Ja</label>
                        </div>
                        <div className="custom-radio__container">
                            <input className="custom-radio__input"
                                id="No"
                                name="customisation-choice"
                                type="radio"
                                value="no"
                                hidden
                                checked={!this.state.IsAdventCalendar}
                            />
                            <label onClick={(event) => { this.LabelClicked(event, t) }} className="custom-radio__label custom-radio__label_content--option-name" for="No">Nein</label>
                        </div>
                        {
                            this.state.isMobile ? null :
                                <img src="/resources/images/rewe/prize-3.png" alt="Special Product" />
                        }

                        {
                            this.state.IsAdventCalendar
                            &&
                            (
                                <p>
                                    Solltest du keinen Kassenbon hochgeladen haben, kannst du hier den Produktcode deines Milka & REWE Adventskalenders eingeben um an der Sonderverlosung vom 1.12.-24.12.2021 teilzunehmen. So hast du täglich die Chance auf 1 von 5x 200€ REWE Gutscheinen und zusätzlich spenden wir pro Gewinner 20€ an Tafel Deutschland e.V.
                                </p>
                            )
                        }

                    </div>
                    {
                        this.state.IsAdventCalendar
                        &&
                        (
                            <div className="campaign-code">
                                <h4>Gib hier den Produktcode deines Adventskalenders ein:</h4>
                                <div className="campaign-code-container">
                                    <picture>
                                        <source srcSet="/resources/images/rewe/code-notice-big.png" media="(min-width: 1024px)" />
                                        <source srcSet="/resources/images/rewe/code-notice-big.png" media="(min-width: 481px)" />
                                        <source srcSet="/resources/images/rewe/code-notice.png" media="(min-width: 200px)" />
                                        <img src="/resources/images/rewe/code-notice.png" alt="Produktcode" />
                                    </picture>
                                    {/*<p id="info">Der Produktcode besteht aus Zahlen und Buchstaben. (Hinweis: Befindet sich kein Produktcode auf dem Artikel, so müssen die Zahlen beim Barcode eingegeben werden.)</p>*/}
                                    <label>Produktcode-Eingabe</label>
                                    <input className={this.state.CodeIsValid ? "campaign-code-input" : "campaign-code-input notvalid"}
                                        type="text"
                                        placeholder="CWS1218621"
                                        onChange={() => {
                                            if (this._DETAILS_ProductCode.value.length > 0 || this._RECEIPT_file.files.length >= 1) {
                                                this.setState({
                                                    CodeIsValid: true
                                                })
                                            } else {
                                                this.setState({
                                                    CodeIsValid: false
                                                })
                                            }
                                        }}
                                        ref={input => this._DETAILS_ProductCode = input}
                                    />
                                </div>
                            </div>
                        )
                    }
                </div>
                {
                    window.PROMOTION_CAMPAIGN == "rewe"
                    &&
                    <div className="campaign-form-receipt">
                        <h3>Angaben zum Kauf</h3>
                        {this.DisplayDateAndProductCount(t)}
                    </div>
                }
            </>
        );
    }

    handleChange = (e, stateName) => {
        this.setState({ [stateName]: e.target.value });
    };

    DisplayParticipantForm(t) {
        const terms2 = t('Page.Participation.Form.Sections.Details.Field.Terms2', { returnObjects: true });
        let terms2Html = null;
        if (terms2 !== null && terms2 !== undefined) {
            terms2Html = (
                <div className="input-container">
                    <label className="custom-inputs" htmlFor="terms2">
                        <span className="text-content" >
                            {parse(terms2.HTML)}
                        </span>
                        <input type="checkbox" id="terms2" name="terms2" className="js-event-type-in js-event-ab" data-require="false"
                            onClick={() => this.googleTag('checkbox_conditions', 'Start Page', 'Click on Checkbox', 'EASTER_SP_PART')}
                        />

                        <span className="checkmark"></span>
                    </label>
                </div>
            );
        }

        return (
            //huhu form
            <div className="campaign-form-participation form-content-participation">
                <h2 className="title-participation">{t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Title}</h2>
                <h3 className="subtitle-participation">{this.state.isMobile ? parse(t("Page.Participation.Form.Sections.Details.SubtitleMob")): parse(t("Page.Participation.Form.Sections.Details.Subtitle"))}</h3>
                <div className="form-container" id="UserDetails">
                    <p>Pflichtfelder*</p>
                    <div id="salutation" className="input-container">
                        <div className="form-input__container">
                            <select ref={select => this._DETAILS_salutation = select} className="form-input__input js-event-type-in js-event-ab"
                                type={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Salutation.Type}
                                name={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Salutation.Id}
                                id="salutation"
                                placeholder={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Salutation.Label}
                                data-require={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Salutation.Required}
                                data-type="text"
                                data-error-target={`#error-${t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Salutation.Id}`}
                                data-required-message=""
                                data-event-fieldname="Salutation"
                                data-event="form-click"
                                data-category="Form Action"
                                data-action="Salutation"
                                data-label="Type In">
                                {
                                    Object.keys(Salutations.dropdown).map(key => {
                                        var i = 0;
                                        return <option style={{color:'black', fontFamily:'Good Headline Pro'}} value={key} key={`${i++}-${key}`} >{Salutations.dropdown[key]}</option>
                                    })
                                }
                            </select>

                        </div>
                    </div>
                    <div id="firstName" className="input-container">
                        <div className="form-input__container">
                            {/* <label className="form-input__label" htmlFor={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.FirstName.Id} >{t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.FirstName.Label}</label> */}
                            <input className="form-input__input js-event-type-in js-event-ab"
                                type={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.FirstName.Type}
                                name={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.FirstName.Id}
                                id={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.FirstName.Id}
                                placeholder={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.FirstName.Label}
                                data-require={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.FirstName.Required}
                                data-error-target={`#error-${t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.FirstName.Id}`}
                                data-regex-pattern="^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ðß ,.'-]+$"
                                data-type="regex"
                                data-required-message=""
                                data-pattern-message=""
                                data-event-fieldname="Firstname"
                                data-event="form-click"
                                data-category="Form Action"
                                data-action="Firstname"
                                data-label="Type In"
                                ref={input => this._DETAILS_firstName = input}
                            />
                        </div>
                    </div>
                    <div id="lastName" className="input-container">
                        <div className="form-input__container">
                            {/* <label className="form-input__label" htmlFor={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.LastName.Id} >{t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.LastName.Label}</label> */}
                            <input className="form-input__input js-event-type-in js-event-ab"
                                type={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.LastName.Type}
                                name={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.LastName.Id}
                                id={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.LastName.Id}
                                placeholder={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.LastName.Label}
                                data-require={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.LastName.Required}
                                data-type="regex"
                                data-error-target={`#error-${t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.LastName.Id}`}
                                data-regex-pattern="^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ðß ,.'-]+$"
                                data-required-message=""
                                data-pattern-message=""
                                data-event-fieldname="Lastname"
                                data-event="form-click"
                                data-category="Form Action"
                                data-action="Lastname"
                                data-label="Type In"
                                ref={input => this._DETAILS_lastName = input}
                            />
                        </div>
                    </div>
                    <div id="email" className="input-container">
                        <div className="form-input__container">
                            {/* <label className="form-input__label" htmlFor={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Id} >{t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Label}</label> */}
                            <input className="form-input__input js-event-type-in js-event-ab"
                                type={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Type}
                                name={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Id}
                                id={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Id}
                                placeholder={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Label}
                                data-require={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Required}
                                data-type="regex"
                                data-error-target={`#error-${t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Id}`}
                                data-regex-pattern="^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[A-Za-z]{2,17}$"
                                data-required-message=""
                                data-pattern-message="Ups, da hat sich wohl ein Fehler in die E-Mail-Adresse eingeschlichen. Bitte überprüfe deine E-Mail."
                                data-event-fieldname="Email"
                                data-event="form-click"
                                data-category="Form Action"
                                data-action="Email"
                                data-label="Type In"
                                ref={input => this._DETAILS_email = input}
                            />

                            <span id={`error-${t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Id}`} className="form-input__error active"></span>
                        </div>
                    </div>
                    <div id="strabe" className="input-container">
                        <div className="form-input__container">
                            {/* <label className="form-input__label" htmlFor={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Id} >{t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Label}</label> */}
                            <input              
                                className="form-input__input js-event-type-in js-event-ab"
                                type={
                                    t("Page.Participation.Form.Sections.Details", {
                                        returnObjects: true,
                                    }).Field.Street.Type
                                }
                                name={
                                    t("Page.Participation.Form.Sections.Details", {
                                        returnObjects: true,
                                    }).Field.Street.Id
                                }
                                id={
                                    t("Page.Participation.Form.Sections.Details", {
                                        returnObjects: true,
                                    }).Field.Street.Id
                                }
                                placeholder={
                                    t("Page.Participation.Form.Sections.Details", {
                                        returnObjects: true,
                                    }).Field.Street.Label
                                }
                                data-require={
                                    t("Page.Participation.Form.Sections.Details", {
                                        returnObjects: true,
                                    }).Field.Street.Required
                                }
                                data-type="text"
                                data-error-target={`#error-${t("Page.Participation.Form.Sections.Details", {
                                    returnObjects: true,
                                }).Field.Street.Id
                                    }`}
                                data-required-message=""
                                data-event-fieldname="Street"
                                data-event="form-click"
                                data-category="Form Action"
                                data-action="Street"
                                data-label="Type In"
                                ref={(input) => (this._DETAILS_street = input)}
                            />
                            <span id={`error-${t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Email.Id}`} className="form-input__error active"></span>
                        </div>
                    </div>
                    <div id="houseNumber" className="input-container">
                        <div className="form-input__container">
                            {/* <label className="form-input__label" htmlFor={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.HouseNumber.Id} >{t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.HouseNumber.Label}</label> */}
                            <input
                                className="form-input__input js-event-type-in js-event-ab"
                                type={
                                    t("Page.Participation.Form.Sections.Details", {
                                        returnObjects: true,
                                    }).Field.HouseNumber.Type
                                }
                                name={
                                    t("Page.Participation.Form.Sections.Details", {
                                        returnObjects: true,
                                    }).Field.HouseNumber.Id
                                }
                                id={
                                    t("Page.Participation.Form.Sections.Details", {
                                        returnObjects: true,
                                    }).Field.HouseNumber.Id
                                }
                                placeholder={
                                    t("Page.Participation.Form.Sections.Details", {
                                        returnObjects: true,
                                    }).Field.HouseNumber.Label
                                }
                                data-require={
                                    t("Page.Participation.Form.Sections.Details", {
                                        returnObjects: true,
                                    }).Field.HouseNumber.Required
                                }
                                data-type="text"
                                data-error-target={`#error-${t("Page.Participation.Form.Sections.Details", {
                                    returnObjects: true,
                                }).Field.HouseNumber.Id
                                    }`}
                                data-required-message=""
                                data-event-fieldname="HouseNumber"
                                data-event="form-click"
                                data-category="Form Action"
                                data-action="HouseNumber"
                                data-label="Type In"
                                ref={(input) => (this._DETAILS_houseNumber = input)}
                            />
                        </div>
                    </div>
                    <div id="address" className="input-container">
                        <div className="form-input__container">
                            {/* <label className="form-input__label" htmlFor={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Address.Id} >{t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.Address.Label}</label> */}
                            <input
                                className="form-input__input js-event-type-in js-event-ab"
                                type={
                                    t("Page.Participation.Form.Sections.Details", {
                                        returnObjects: true,
                                    }).Field.Address.Type
                                }
                                name={
                                    t("Page.Participation.Form.Sections.Details", {
                                        returnObjects: true,
                                    }).Field.Address.Id
                                }
                                id={
                                    t("Page.Participation.Form.Sections.Details", {
                                        returnObjects: true,
                                    }).Field.Address.Id
                                }
                                placeholder={
                                    t("Page.Participation.Form.Sections.Details", {
                                        returnObjects: true,
                                    }).Field.Address.Label
                                }
                                data-require={
                                    t("Page.Participation.Form.Sections.Details", {
                                        returnObjects: true,
                                    }).Field.Address.Required
                                }
                                data-type="text"
                                data-error-target={`#error-${t("Page.Participation.Form.Sections.Details", {
                                    returnObjects: true,
                                }).Field.Address.Id
                                    }`}
                                data-required-message=""
                                data-event-fieldname="Address"
                                data-event="form-click"
                                data-category="Form Action"
                                data-action="Address"
                                data-label="Type In"
                                ref={(input) => (this._DETAILS_Address = input)}
                            />
                        </div>
                    </div>
                    <div id="zip-code" className="input-container">
                        <div className="form-input__container">
                            {/* <label className="form-input__label" htmlFor={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.ZipCode.Id} >{t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.ZipCode.Label}</label> */}
                            <input
                                className="form-input__input js-event-type-in js-event-ab"
                                type={
                                    t("Page.Participation.Form.Sections.Details", {
                                        returnObjects: true,
                                    }).Field.ZipCode.Type
                                }
                                name={
                                    t("Page.Participation.Form.Sections.Details", {
                                        returnObjects: true,
                                    }).Field.ZipCode.Id
                                }
                                id={
                                    t("Page.Participation.Form.Sections.Details", {
                                        returnObjects: true,
                                    }).Field.ZipCode.Id
                                }
                                placeholder={
                                    t("Page.Participation.Form.Sections.Details", {
                                        returnObjects: true,
                                    }).Field.ZipCode.Label
                                }
                                data-require={
                                    t("Page.Participation.Form.Sections.Details", {
                                        returnObjects: true,
                                    }).Field.ZipCode.Required
                                }
                                data-type="regex"
                                data-error-target={`#error-${t("Page.Participation.Form.Sections.Details", {
                                    returnObjects: true,
                                }).Field.ZipCode.Id
                                    }`}
                                //data-regex-pattern="^[1-9][0-9]{3}[0-8]|[1-8][0-8]{3}[0-9]|010[6-9][7-9]$"
                                data-regex-pattern="^[0-9]{4}$"
                                data-required-message=""
                                maxLength={4}
                                data-event-fieldname="ZipCode"
                                data-event="form-click"
                                data-category="Form Action"
                                data-action="ZipCode"
                                data-label="Type In"
                                ref={(input) => (this._DETAILS_ZipCode = input)}
                                onInput={(e) => {
                                    e.currentTarget.value = e.currentTarget.value.replace(/[^0-9]/g, '');
                                  }}
                            />
                        </div>
                    </div>
                    <div id="city" className="input-container">
                        <div className="form-input__container">
                            {/* <label className="form-input__label" htmlFor={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.City.Id} >{t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.City.Label}</label> */}
                            <input
                                className="form-input__input js-event-type-in js-event-ab"
                                type={
                                    t("Page.Participation.Form.Sections.Details", {
                                        returnObjects: true,
                                    }).Field.City.Type
                                }
                                name={
                                    t("Page.Participation.Form.Sections.Details", {
                                        returnObjects: true,
                                    }).Field.City.Id
                                }
                                id={
                                    t("Page.Participation.Form.Sections.Details", {
                                        returnObjects: true,
                                    }).Field.City.Id
                                }
                                placeholder={
                                    t("Page.Participation.Form.Sections.Details", {
                                        returnObjects: true,
                                    }).Field.City.Label
                                }
                                data-require={
                                    t("Page.Participation.Form.Sections.Details", {
                                        returnObjects: true,
                                    }).Field.City.Required
                                }
                                data-type="text"
                                data-error-target={`#error-${t("Page.Participation.Form.Sections.Details", {
                                    returnObjects: true,
                                }).Field.City.Id
                                    }`}
                                maxLength={50}
                                data-required-message=""
                                data-event-fieldname="City"
                                data-event="form-click"
                                data-category="Form Action"
                                data-action="City"
                                data-label="Type In"
                                ref={(input) => (this._DETAILS_City = input)}
                            />
                        </div>
                    </div>
                    {/* {
                        !this.state.isMobile ? (
                            <div className="input-container"></div>
                        ) : (null)
                    } */}

                </div>
                <div className="input-container">
                    <label style={{marginTop: '40px'}}className="custom-inputs" htmlFor="terms">
                        <span className="text-content">
                            Ich habe die&nbsp;
                            <NavLink to={GLOBAL_CONFIG.Route.terms} target="_blank" exact data-event="click_conditions" data-category="Start Page" data-action="Click on Conditions of Participation" data-label="ENG_SP_PART" onClick={appGoogleTracking.processEventCTANavLink}>Teilnahmebedingungen</NavLink> 
                              &nbsp;gelesen und akzeptiert.*<br />
                            <span id="error-terms" className="form-input__error active"></span>
                        </span>

                        <input ref={check => this._DETAILS_Terms = check} type="checkbox" id="terms" name="terms" className="js-event-type-in js-event-ab" data-require="true" data-type="checkbox" data-error-target="#error-terms" data-required-message="Bitte akzeptiere die Teilnahmebedingungen, um fortzufahren." data-event-fieldname="Terms"
                            onClick={() => this.googleTag('click_conditions_join_now', 'Start Page', 'Click on Conditions', 'ENG_SP_FORM')}
                        />
                        <span className="checkmark"></span>
                    </label>
                </div>
                <div className="input-container">
                    <label className="custom-inputs" htmlFor="country">
                        <span className="text-content">
                            Ja, ich lebe in Österreich.* <br />
                            <span id="error-country" className="form-input__error active"></span>
                        </span>

                        <input ref={check => this._DETAILS_country = check} type="checkbox" id="country" name="country" className="js-event-type-in js-event-ab" data-require="true" data-type="checkbox" data-error-target="#error-country" data-required-message="Bitte bestätige hier, dass du in Österreich lebt." data-event-fieldname="country"
                            onClick={() => this.googleTag('checkbox_austria_confirmation', 'Start Page', 'Click on Checkbox', 'ENG_SP_FORM')}
                        />
                        <span className="checkmark"></span>
                    </label>
                </div>
                <div className="input-container">
                    <label className="custom-inputs" htmlFor="is18">
                        <span className="text-content">
                            Ja, ich bin mindestens 18 Jahre alt.* <br />
                            <span id="error-is18" className="form-input__error active"></span>
                        </span>

                        <input ref={check => this._DETAILS_is18 = check} type="checkbox" id="is18" name="is18" className="js-event-type-in js-event-ab" data-require="true" data-type="checkbox" data-error-target="#error-is18" data-required-message="Bitte bestätige hier, dass du mindestens 18 Jahre alt bist." data-event-fieldname="is18"
                            onClick={() => this.googleTag('checkbox_age_confirmation', 'Start Page', 'Click on Checkbox', 'ENG_SP_FORM')}
                        />
                        <span className="checkmark"></span>
                    </label>
                </div>
                {terms2Html}
                <div className="input-container">
                    <label className="custom-inputs" htmlFor="newsletter" >
                        <span className="text-content link" style={{ marginRight: '10px' }}>
                            {parse(t('Page.Participation.Form.Sections.Details.Field.Newsletter.HTML'))}
                        </span>
                        <input ref={check => this._DETAILS_News = check} type="checkbox" id="newsletter" name="newsletter" className="js-event-type-in js-event-ab" data-require="false" data-event-fieldname="Newsletter"
                            onClick={() => this.googleTag('checkbox_subscribe_newsletter', 'Start Page', 'Click on Checkbox', 'ENG_SP_PART')}
                        />
                        <span className="checkmark"></span>
                    </label>
                </div>
                <div className='newsletter2'>
                    <span className='text-content'>
                        Wir schätzen dein Vertrauen, wenn du deine personenbezogenen Daten mit uns teilst. 
                        Deine Daten werden von uns ausschließlich zur Beantwortung deiner Anfrage genutzt. 
                        Wir behandeln deine Daten stets fair, respektvoll und ausschließlich zu dem genannten Zweck. 
                        Ein Widerruf der Einwilligung zur vorübergehenden Speicherung deiner Daten ist jederzeit möglich. 
                        Für weitere Informationen lies bitte{" "} 
                        <a 
                            href="https://privacy.mondelezinternational.com/eu/de-DE/privacy-notice/" 
                            target="_blank" 
                            data-event="data_protection" 
                            data-category="Start Page" 
                            data-action="Click on Data Protection" 
                            data-label="ENG_SP_OTHER" 
                            onClick={appGoogleTracking.processEventCTANavLink}
                            >hier</a>{" "} 
                            unsere Datenschutzerklärung, erfahre, wie wir mit deinen Daten umgehen und wie du deine Rechte 
                            ausüben kannst. <br/> <br/> Gib deine persönlichen Daten (Vor- und Nachname sowie die E-Mail-Adresse, 
                            Geburtsdatum, Wohnadresse) ein. Lies dir bitte vorher unsere{" "}  
                            <a 
                                href=" https://privacy.mondelezinternational.com/eu/de-DE/privacy-notice/" 
                                target="_blank" 
                                data-event="click_privacy_policy" 
                                data-category="Start Page" 
                                data-action="Click on Data Protection Regulations" 
                                data-label="ENG_SP_OTHER" 
                                onClick={appGoogleTracking.processEventCTANavLink}>
                                Datenschutzerklärung</a>{" "} aufmerksam durch, damit du weißt, wie wir mit 
                                deinen personenbezogenen Daten umgehen und welche Rechte dir zustehen.
                    </span>
                </div>
            </div>
        );
    }

    calculateAge(birthday) {
        const ageDifMs = Date.now() - birthday;
        const ageDate = new Date(ageDifMs);
        return Math.abs(ageDate.getUTCFullYear() - 1970);
    }

    async isNumber(...n) {
        for (let i = 0; i < n.length; i++) {
            if (Number(n[i]) != n[i]) {
                return false;
            }
        }
        return true;
    }

    checkMinimumAge(e, regex) {
        if (!e.target.value.match(regex)) {
            e.target.classList.remove("valid");
            e.target.classList.add("notvalid");
        } else {
            e.target.classList.remove("notvalid");
            e.target.classList.add("valid");
        }
        const day = document.querySelector("input#day"),
            month = document.querySelector("input#month"),
            year = document.querySelector("input#year");
        if (day && month && year) {
            const dayValue = day.value,
                monthValue = month.value,
                yearValue = year.value;



            if (dayValue && monthValue && yearValue) {
                const birthday = new Date(yearValue, monthValue - 1, dayValue);
                const age = this.calculateAge(birthday);
                this.isNumber(dayValue, monthValue, yearValue).then((val) => {
                    let isTTOk = true;
                    let isMMOk = true;
                    if (dayValue > 31) {
                        isTTOk = false;
                    }
                    if (monthValue > 12) {
                        isMMOk = false;
                    }
                    if (!val || age < 18 || age > 100 || isTTOk == false || isMMOk == false) {
                        day.classList.remove("valid");
                        month.classList.remove("valid");
                        year.classList.remove("valid");

                        day.classList.add("notvalid");
                        month.classList.add("notvalid");
                        year.classList.add("notvalid");
                    } else {
                        day.classList.remove("notvalid");
                        month.classList.remove("notvalid");
                        year.classList.remove("notvalid");

                        day.classList.add("valid");
                        month.classList.add("valid");
                        year.classList.add("valid");

                    }
                });
            }
        }
    }

    LabelClicked(e, t) {
        var id = e.target.getAttribute("for"),
            radio = document.getElementById(id),
            value = radio.value || "no";

        if (!radio.checked) {
            radio.checked = true
        }
        if (value === "yes") {
            this.setState({
                IsAdventCalendar: true
            })
            const spanFileError = document.querySelector(".form-input__error.js-file-error");
            if (spanFileError) {
                spanFileError.classList.remove("active");
            }
        } else {
            this.setState({
                IsAdventCalendar: false
            });

        }
        this.checkProductName(value, t);
    }

    checkMinValueOfProductName(minValue, t) {
        const selectProductName = document.getElementById("product-amount");
        if (selectProductName.value === "default" || parseInt(minValue) > parseInt(selectProductName.value)) {
            this.setState({ IsProductNameInvalid: true });
            selectProductName.classList.add('notvalid');
            selectProductName.classList.remove('valid');
        } else {
            this.setState({ IsProductNameInvalid: false });
            selectProductName.classList.remove('notvalid');
            selectProductName.classList.add('valid');
        }
    }

    checkProductName(value, t) {
        let minValue = t("Page.Participation.Form.Sections.Receipt.Field.ProductName.MinValue", { returnObjects: true });
        if (value === "yes") {
            if (window.PROMOTION_CAMPAIGN === "rewe") {
                minValue = t("Page.Participation.Form.Sections.Receipt.Field.Name.MinValueAdventCalendar", { returnObjects: true });
            }
        }
        this.checkMinValueOfProductName(minValue, t);
    }

    //Form abondonment - Tracking for Tagging plan
    handleUnload(e) {

        return appGoogleTracking.dataLayerPush({
            'dataEvent': 'form-click',
            'dataCategory': 'Form Action',
            'dataAction': 'Form Abandonment',
            'dataLabel': appGoogleTracking.fieldConcat
        });
    }

    //Two way binding for input fields
    onChangeHandler = (event) => {
        let e = event.target,
            val = e.value;

        setTimeout(() => {
            let msgID = document.getElementById('purchaseamount-warning'),
                msgEuroID = document.getElementById('purchaseamount-warning-euro');
            //sumSelector = document.getElementById('js-sum-display');

            if (val.indexOf('€') > -1) {
                msgEuroID.classList.add('active-success');
                msgID.classList.remove('active-success');
            } else if (val > 200) {  //200
                msgID.classList.add('active-success');
                msgEuroID.classList.remove('active-success');
            } else {
                msgID.classList.remove('active-success');
                msgEuroID.classList.remove('active-success');
            }
        }, 300);
    }

    //Close error message popup
    onClosePopupHandler = () => {
        this.setState({
            loaderError: false,
            loaderGeneralError: false
        });
    }

    //Form submit event
    onSubmitHandler(event) {
        event.preventDefault();
        //Validation of fields

        let validateForm = ValidateForm.validateForm('frm_participation');
        if (!this._RECEIPT_file.files.length >= 1) {
            this.setState({ errorFile: true })
            validateForm = false;
        }

        if (validateForm === true) {
            //Trigger captcha
            this.TriggerCaptcha();
            // }
        } else {
            const errorField = document.querySelector('.notvalid');
            if (errorField) {
                errorField.focus();
            }
            const errorFile = document.querySelector(".form-input__error.js-file-error.active");
            if (errorFile) {
                const headerHeight = 400; // Adjust this if your header height changes
                const sectionPosition = errorFile.getBoundingClientRect().top + window.scrollY - headerHeight;
                window.scrollTo({ top: sectionPosition, behavior: 'smooth' });
            }
        }
    }


    //Trigger the captcha
    TriggerCaptcha() {
        //Process captcha - after which form ajax will be handle
        if (this._CAPTCHA.getResponse() !== '') {
            this._CAPTCHA.reset();
        } else {
            this._CAPTCHA.execute();
        }
    }

    //When captcha is good -> Callback when Google capture is good
    onResolved = (token) => {
        //Process form
        this.ProcessFormData(token);
        // alert('resolve')
    }

    //Construct server date : YYY-MM-DD
    serverDate = (date) => {
        let setDate = date.split('.');
        return setDate[2] + '-' + setDate[1] + '-' + setDate[0];
    }

    serverDateDMY = (day, month, year) => {
        return year + '-' + month + '-' + day;
    }

    //Trigger datalayer push when form is successful
    triggerDatalayers = (param) => {
        if (param.status === 'success') {
            let retailerPlace = this._RECEIPT_RetailerParnet.value,
                datePurchase = this.state.selectedRetailerPartner;
            //Product retailer place
            appGoogleTracking.dataLayerPush({
                'dataEvent': 'button-click',
                'dataCategory': 'Click Action',
                'dataAction': 'Form Submission',
                'dataLabel': param.participationID
            });

            //Valid participation
            appGoogleTracking.dataLayerPush({
                'dataEvent': 'form-click',
                'dataCategory': 'Form Action',
                'dataAction': 'Form Validated',
                'dataLabel': param.participationID
            });

            //Receipt upload
            appGoogleTracking.dataLayerPush({
                'dataEvent': 'button-click',
                'dataCategory': 'Click Action',
                'dataAction': 'Upload Receipt',
                'dataLabel': timeStamp()
            });

            //Date purchase
            appGoogleTracking.dataLayerPush({
                'dataEvent': 'button-click',
                'dataCategory': 'Click Action',
                'dataAction': 'Date of Purchase',
                'dataLabel': datePurchase
            });

            //Place of Purchasse
            appGoogleTracking.dataLayerPush({
                'dataEvent': 'button-click',
                'dataCategory': 'Click Action',
                'dataAction': 'Amount Purchased',
                'dataLabel': retailerPlace
            });
        } else if (param.status === 'error') {
            if (param.type === 'participate') {
                appGoogleTracking.dataLayerPush({
                    'dataEvent': 'form-click',
                    'dataCategory': 'Form Action',
                    'dataAction': 'Already Participated',
                    'dataLabel': timeStamp()
                });
            } else {
                appGoogleTracking.dataLayerPush({
                    'dataEvent': 'form-click',
                    'dataCategory': 'Form Action',
                    'dataAction': 'Form Not Valid',
                    'dataLabel': 'Error Type'
                });
            }
        }
    }


    //Process form when Captcha is OK
    ProcessFormData(token) {
        //Open loader
        this.setState({
            loaderSubmit: true,
        });
        let fileUploaded = null;
        let receiptprice = 0;

        fileUploaded = this._RECEIPT_file.files[0];

        if (this._RECEIPT_ReceiptPrice) {
            receiptprice = this._RECEIPT_ReceiptPrice.value
        }

        let retailerToSend = this.state.selectedRetailer;
        let retailerPartnerToSend = this.state.selectedRetailerPartner;



        if (retailerToSend && !this.state.showRetailerPartner) {
            retailerPartnerToSend = retailerToSend
        }



        ////gestion formulaire data
        let salutation = this._DETAILS_salutation.value;
        switch (salutation) {
            case "Herr":
                salutation = 1;
                break;
            case "Frau":
                salutation = 2;
                break;
            case "Divers":
                salutation = 10;
                break;

            default:
                break;
        }
        let data = {
            salutation: salutation,
            firstname: this._DETAILS_firstName.value,
            lastname: this._DETAILS_lastName.value,
            email: this._DETAILS_email.value,
            
            street1: this._DETAILS_street.value,
            streetnumber: this._DETAILS_houseNumber.value,
            street2: this._DETAILS_Address.value,
            zipcode: this._DETAILS_ZipCode.value,
            city: this._DETAILS_City.value,
            newsletter: this._DETAILS_News.checked ? 1 : 0,
            privacyPolicy: this._DETAILS_Terms.checked ? 1 : 0,
            purchaseAmount: this._RECEIPT_SumReceipt.value,
            purchaseProducts: this._RECEIPT_ProductName.value,
            retailer: retailerToSend,
            retailerPartner: retailerPartnerToSend,
            purchaseDate: this.serverDate(this._RECEIPT_ReceiptDate.value),
            file: fileUploaded,
            recaptcha: token
        };

        localStorage.setItem('retailer', data.retailerPartner)
        


        if (window.PROMOTION_CAMPAIGN == "kaufland") {
            //Form Data is used to passe the receipt as binary
            let _data = new FormData();


            for (let key in data) {
                _data.append(key, data[key]);
            }

            CampaignServices.Participate({
                data: _data,
                retailerPartner: window.PROMOTION_CAMPAIGN,
            })
                .then((response) => {
                    let { success, message, ParticipationId, data } = response.data;

                    if (success) {

                        appGoogleTracking.dataLayerPush({
                            dataEvent: "join_now",
                            dataCategory: "Take Part Page",
                            dataAction: "Click on Join Now",
                            dataLabel: "EASTER_TPP_PART",
                        });

                        sessionStorage.setItem(
                            GLOBAL_CONFIG.Session.userinfo,
                            JSON.stringify(data));
                        sessionStorage.setItem(
                            GLOBAL_CONFIG.Session.userstatus,
                            "Noparticipate"
                        );
                        this.props.history.push({ pathname: GLOBAL_CONFIG.Route.spin });
                        this.setState({
                            loaderSubmit: false,
                        });
                        //Go to Thank you page
                    } else {
                        let errorStatus = data.Error[0];
                        this.setState({
                            loaderSubmit: false,
                        });

                        if (!!errorStatus) {
                            if (window.PROMOTION_CAMPAIGN !== "kaufland") {
                                // sessionStorage.setItem(
                                //   GLOBAL_CONFIG.Session.userstatus,
                                //   "participateAlreadyWin"
                                // );
                                
                                this.props.history.push({ pathname: GLOBAL_CONFIG.Route.spin });
                            }

                        }
                        this._CAPTCHA.reset();
                    }

                })
                .catch((error) => {
                    let { Data } = error.response.data,
                        errorStatus = Data.Error[0] || "";
                    this.setState({
                        loaderSubmit: false,
                    });
                    this.ProcessError(errorStatus);

                    this._CAPTCHA.reset();
                });
        } else {
            this.setState({
                loaderSubmit: true,
            });
            appGoogleTracking.dataLayerPush({
                dataEvent: "spin_the_wheel",
                dataCategory: "Start Page",
                dataAction: "Click on Spin Now",
                dataLabel: "GAME_SP_FORM",
            });
            fileUploaded = this._RECEIPT_file.files[0];
            data.fileinput = fileUploaded.name;
            sessionStorage.setItem(
                GLOBAL_CONFIG.Session.userstatus,
                "participate"
            );
            sessionStorage.setItem(GLOBAL_CONFIG.Session.userinfo,JSON.stringify(data));
            this.storeFileInIndexedDB(fileUploaded, (message) => {
                if (fileUploaded) {
                    this.props.history.push({ pathname: GLOBAL_CONFIG.Route.spin });
                } else {
                    this.setState({ errorMessage: "No file uploaded. Please upload a file." });
                }
            });
        }










        // for (let key in data) {
        //     _data.append(key, data[key]);
        // }

        // CampaignServices.Participate({ data: _data, retailer: window.PROMOTION_CAMPAIGN })
        //     .then((response) => {
        //         console.log('response', response);
        //         let { success, message, data } = response.data;

        //         if (success) {

        //             let fullname = this._DETAILS_firstName.value + " " + this._DETAILS_lastName.value; // Combine first and last name with a space

        //             data.fullname = fullname;
        //             sessionStorage.setItem(
        //                 GLOBAL_CONFIG.Session.userinfo,
        //                 JSON.stringify(data)
        //             ); // Store the updated data in sessionStorage
        //             // //Datalayer push for Success participation
        //             // this.triggerDatalayers({
        //             //     status: 'success',
        //             //     participationID: ParticipationId
        //             // });
        //             // this.googleTag('Take Part Page', 'Start Page', 'Click on Register', 'EASTER_SP_PART');
                 
        //                 appGoogleTracking.dataLayerPush({
        //                     dataEvent: "join_now",
        //                     dataCategory: "Take Part Page",
        //                     dataAction: "Click on Join Now",
        //                     dataLabel: "EASTER_TPP_PART",
        //                 });
                 
        //             // //Go to Thank you page
        //             this.props.history.push({ pathname: GLOBAL_CONFIG.Route.thankyou });

        //         } else {
        //             // alert('some error')
        //             let errorStatus = data.Error[0];
        //             if (!!errorStatus) {
        //                 this.ProcessError(errorStatus)
        //             }
        //             this._CAPTCHA.reset();
        //         }
        //     })
        //     .catch((error) => {
        //         let { Data } = error.response.data,
        //             errorStatus = Data.Error[0] || "";

        //         this.ProcessError(errorStatus)

        //         this._CAPTCHA.reset();
        //     });
    }

    ProcessError(_ERR) {
        switch (_ERR.toUpperCase()) {
            case "NUMBEROFPARTICIPATION_INVALID":
                this.setState({
                    loaderSubmit: false,
                    loaderError: true,
                    genericErrorMessage: this.errorMessage
                });

                this.triggerDatalayers({
                    status: 'error',
                    type: 'participate'
                });
                break;
            case "INVALID_RECAPTCHA_RESPONSE":
                this.setState({
                    loaderSubmit: false,
                    loaderGeneralError: true,
                    genericErrorMessage: this.errorMessage
                });

                this.triggerDatalayers({
                    status: 'error',
                    type: 'general'
                });
                break;

            case "INVALID_LOTCODE":
                this.setState({
                    loaderSubmit: false,
                    loaderGeneralError: true,
                    CodeIsValid: false,
                    genericErrorMessage: "INVALID_LOTCODE"
                });

                if (!!this._DETAILS_ProductCode) {
                    this._DETAILS_ProductCode.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
                this.errorMessage = "Du hast keinen gültigen Produktcode eingegeben. Bitte versuche es erneut oder lade deinen Kassenbon hoch.";
            default:
                this.setState({
                    loaderSubmit: false,
                    loaderGeneralError: true,
                    genericErrorMessage: this.errorMessage
                });
                break;
        }
    }

    googleTag = (event, category, action, label) => {
        appGoogleTracking.dataLayerPush({
            'dataEvent': event,
            'dataCategory': category,
            'dataAction': action,
            'dataLabel': label
        })
    }
    // storeFileInIndexedDB(file, callback) {



    //     const request = window.indexedDB.open('fileDatabase', 1);
    //     request.onupgradeneeded = (event) => {
    //         const db = event.target.result;
    //         db.createObjectStore('files', { keyPath: 'name' });
    //     };

    //     request.onsuccess = (event) => {
    //         const db = event.target.result;
    //         const transaction = db.transaction('files', 'readwrite');
    //         const objectStore = transaction.objectStore('files');

    //         const fileData = {
    //             name: file.name,
    //             type: file.type,
    //             content: file,
    //         };
    //         // let concat = `${file.name}.${file.type}`;
    //         objectStore.add(fileData);
    //         transaction.oncomplete = () => {
    //             db.close();
    //             callback('File stored in IndexedDB.');
    //         };
    //     };
    //     request.onerror = (event) => {
    //         console.log('----------->onerror');
    //         console.error('IndexedDB error:', event.target.error);
    //         callback('Error storing the file in IndexedDB.'); // Handle the error gracefully
    //     };
    // }


 storeFileInIndexedDB_old(file, callback) {
    const dbName = 'fileDatabase';
    const objectStoreName = 'files';

    const request = window.indexedDB.open(dbName, 1);

    request.onupgradeneeded = (event) => {
        const db = event.target.result;
        db.createObjectStore(objectStoreName, { keyPath: 'name' });
    };

    request.onsuccess = (event) => {
        const db = event.target.result;
        const transaction = db.transaction(objectStoreName, 'readwrite');
        const objectStore = transaction.objectStore(objectStoreName);

        // Delete existing entry with the same name (assuming 'name' is the key)
        const deleteRequest = objectStore.delete(file.name);

        deleteRequest.onsuccess = () => {
            // Add the new entry
            const newFileData = {
                name: file.name,
                type: file.type,
                content: file,
            };
            objectStore.add(newFileData);

            transaction.oncomplete = () => {
                db.close();
                callback('File stored in IndexedDB.');
            };
        };

        deleteRequest.onerror = (deleteEvent) => {
            console.error('Error deleting existing entry:', deleteEvent.target.error);
            db.close();
            callback('Error storing the file in IndexedDB.'); // Handle the error gracefully
        };
    };

    request.onerror = (event) => {
        console.error('IndexedDB error:', event.target.error);
        callback('Error opening IndexedDB.'); // Handle the error gracefully
    };
}
    storeFileInIndexedDB(file, callback) {
        const dbName = 'fileDatabase';
        const objectStoreName = 'files';

        const request = window.indexedDB.open(dbName, 1);

        request.onupgradeneeded = (event) => {
            const db = event.target.result;
            db.createObjectStore(objectStoreName, { keyPath: 'name' });
        };

        request.onsuccess = (event) => {
            const db = event.target.result;
            const transaction = db.transaction(objectStoreName, 'readwrite');
            const objectStore = transaction.objectStore(objectStoreName);

            // Clear all items from the object store
            const clearRequest = objectStore.clear();

            clearRequest.onsuccess = () => {
                // Add the new entry after clearing
                const newFileData = {
                    name: file.name,
                    type: file.type,
                    content: file,
                };
                objectStore.add(newFileData);

                transaction.oncomplete = () => {
                    db.close();
                    callback('File stored in IndexedDB.');
                };
            };

            clearRequest.onerror = (clearEvent) => {
                console.error('Error clearing entries from the object store:', clearEvent.target.error);
                db.close();
                callback('Error storing the file in IndexedDB.'); // Handle the error gracefully
            };
        };

        request.onerror = (event) => {
            console.error('IndexedDB error:', event.target.error);
            callback('Error opening IndexedDB.'); // Handle the error gracefully
        };
    }

}

export default withTranslation()(withRouter(Participation));